var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-navbar',{attrs:{"toggleable":"","type":"","variant":""}},[_c('div',[_c('b-navbar-brand',{attrs:{"href":"/"}},[_c('img',{staticClass:"logo",attrs:{"src":"/logo.svg","alt":"icon"}}),_vm._v(" WebAttach")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }